import { render } from "./BashTheLimitTalentList.vue?vue&type=template&id=7458bcb5&scoped=true&ts=true&lang=pug"
import script from "./BashTheLimitTalentList.vue?vue&type=script&lang=ts"
export * from "./BashTheLimitTalentList.vue?vue&type=script&lang=ts"

import "./BashTheLimitTalentList.vue?vue&type=style&index=0&id=7458bcb5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7458bcb5"]])

export default __exports__